<template>
  <div class="aftersale-send-dialog">
    <custom-dialog width="1200px" :title="model.title" :visible="visible" v-on="$listeners">
      <div class="dialog-body">
        <h1 class="title" style="margin-bottom: 15px">{{ $t('crm_aftersale_send_sale.ddxqsbslb') }}</h1>
        <div style="margin-bottom: 40px">
          <custom-table type="checkbox" :data="tableList" v-model="selectDevice" tableCode="salesFactorySend" :slots="['hqShipToName']">
            <template slot="hqShipToName" slot-scope="scope">
              <el-tooltip placement="bottom" effect="light" v-if="scope.row.receiveAddress">
                <div slot="content">
                  <div style="padding: 2px 8px">
                    <p style="font-size: 14px; line-height: 24px">{{ $t('crm_aftersale_send_sale.shou_huo_ren') }}： {{ scope.row.receiveAddress.consigneeName }}</p>
                    <p style="font-size: 14px; line-height: 24px">{{ $t('crm_aftersale_send_sale.dian_hua') }}： {{ scope.row.receiveAddress.consigneePhone }}</p>
                    <p style="font-size: 14px; line-height: 24px">
                      {{ $t('crm_aftersale_send_sale.di_zhi') }}： {{ scope.row.receiveAddress.country }}{{ scope.row.receiveAddress.province }}{{ scope.row.receiveAddress.city
                      }}{{ scope.row.receiveAddress.detailAddress }}
                    </p>
                  </div>
                </div>
                <el-button type="text">{{ partyDic[scope.row.hqShipTo] }}</el-button>
              </el-tooltip>
              <el-button v-else type="text">{{ partyDic[scope.row.hqShipTo] }}</el-button>
            </template>
          </custom-table>
          <div class="table-page">
              <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
            </div>
        </div>
        <div class="ub" v-if="false">
          <div class="ub-f1" style="width: 0">
            <div class="search-hd">
              <el-form :inline="true" @submit.native.prevent>
                <el-form-item>
                  <h1 class="title">{{ $t('crm_aftersale_send_sale.shkcsbslb') }}</h1>
                </el-form-item>
                <el-form-item style="float: right; margin-right: 0">
                  <el-input :placeholder="$t('crm_aftersale_send_sale.qsrjsh')" v-model="formSearch.search" clearable @keyup.enter.native="onPageChange({ page: 1 })" style="width: 280px">
                    <el-select v-model="formSearch.productCodes" slot="prepend" :placeholder="$t('Common.com_please_select')" @change="onPageChange({ page: 1 })" style="width: 100px">
                      <el-option v-for="item in tableProductList" :key="item" :label="item" :value="item"></el-option>
                    </el-select>
                  </el-input>
                </el-form-item>
              </el-form>
            </div>
            <div>
              <el-table ref="tb2" v-loading="isLoading" :size="allTableSize" :data="deviceList" height="300px" @selection-change="selectionChange($event, 'deviceIn')" @sort-change="sortChange">
                <el-table-column type="selection" width="44" fixed="left" :selectable="onSelectable"></el-table-column>
                <el-table-column prop="productCode" :label="$t('crm_aftersale_send_sale.chan_pin_xing_hao')" width="120"></el-table-column>
                <el-table-column prop="nextDeviceBizType" :label="$t('crm_aftersale_send_sale.she_bei_lei_xing')" width="120"></el-table-column>
                <el-table-column prop="bodyNum" :label="$t('crm_aftersale_send_sale.ji_shen_hao')" width="160"></el-table-column>
                <el-table-column prop="stockDays" :label="$t('crm_aftersale_send_sale.zai_ku_tian_shu')" show-overflow-tooltip></el-table-column>
              </el-table>
            </div>
            <div class="table-page">
              <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
            </div>
          </div>
          <div class="ubv ub-ac ub-xc" style="padding: 0 18px">
            <div class="btn" @click="onDeviceIn">
              <i class="el-icon-arrow-right"></i>
            </div>
            <div class="btn2" @click="onDeviceOut">
              <i class="el-icon-arrow-left"></i>
            </div>
          </div>
          <div class="ub-f1" style="width: 0">
            <div class="search-hd">
              <el-form :inline="true" @submit.native.prevent>
                <el-form-item>
                  <h1 class="title">{{ $t('crm_aftersale_send_sale.fa_huo_biao') }}</h1>
                </el-form-item>
              </el-form>
            </div>
            <div>
              <el-table ref="tb3" :size="allTableSize" :data="selectDevice" height="300px" @selection-change="selectionChange($event, 'deviceOut')" @sort-change="sortChange">
                <el-table-column type="selection" width="44" fixed="left" :selectable="onSelectable"></el-table-column>
                <el-table-column prop="productCode" :label="$t('crm_aftersale_send_sale.chan_pin_xing_hao')" width="84"></el-table-column>
                <el-table-column prop="nextDeviceBizType" :label="$t('crm_aftersale_send_sale.she_bei_lei_xing')" width="120"></el-table-column>
                <el-table-column prop="bodyNum" :label="$t('crm_aftersale_send_sale.ji_shen_hao')" width="160"></el-table-column>
                <el-table-column prop="stockDays" :label="$t('crm_aftersale_send_sale.zai_ku_tian_shu')" show-overflow-tooltip></el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
        <el-button type="primary" @click="saveInsert" :disabled="!selectDevice.length">{{ $t('Common.com_confirm') }}</el-button>
      </div>
    </custom-dialog>
    <!-- 物流单号 -->
    <enter-logistics-no-dialog v-if="editDialog" :model="editModel" @close="editDialog = false" @confirm="onEditSuccess"></enter-logistics-no-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins.js';
import enterLogisticsNoDialog from '@/components/enterLogisticsNoDialog.vue';

export default {
  components: { enterLogisticsNoDialog },
  mixins: [dialogMixins],
  data() {
    return {
      partyDic: {},
      tableList: [],
      tableProductList: [],
      deviceList: [], // 库存
      selectDevice: [], // 已选
      deviceIn: [],
      deviceOut: [],
      formSearch: {
        search: '',
        productCodes: '',
        bizId: '',
        bizClass: '',
        pageNum: 1,
        pageSize: 20,
      },
      totalRows: 0,

      editModel: {},
      editDialog: false,
    };
  },
  mounted() {
    this.getDeviceList();
    this.getDictionary('crm_receiving_party', (data) => {
      this.partyDic = this.$transformDicValue(data.crm_receiving_party);
    });
  },
  methods: {
    // 发货设备列表
    getDeviceList: function () {
      this.formSearch.bizId = this.model.data.bizId;
      this.formSearch.bizClass = this.model.data.bizClass;
      this.$getJSON(apis.saleOrderPreDeliver, this.formSearch).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getDeviceList();
    },
    onEditSuccess: function (param) {
      // const deviceList = this.selectDevice.map(t => ({
      //   bodyNum: t.bodyNum,
      //   deviceBizType: t.deviceBizType,
      //   deviceId: t.deviceId,
      //   productCode: t.productCode,
      //   modemSn: t.modemSn
      // }));
      this.$postJSON(apis.contractDeliver, {
        bizId: this.model.data.bizId,
        bizClass: this.model.data.bizClass,
        deviceList: this.selectDevice,
        logisticsCompanyCode: param.companyCode,
        logisticsCompany: param.companyName,
        shipmentNum: param.orderNo,
      }).then(() => {
        this.$message({
          message: this.$t('Common.com_handle_success'),
          type: 'success',
        });
        this.$emit('success');
        this.visible = false;
      });
    },
    // 保存新增
    saveInsert: function () {
      this.editModel.title = this.$t('crm_aftersale_send_sale.lu_ru_wu_liu_dan_hao');
      this.editDialog = true;
    },
  },
};
</script>

<style lang="scss">
.aftersale-send-dialog {
  .el-input-group__prepend {
    font-size: 0;
    border-radius: 2px;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .title {
    color: #000000;
    font-weight: bold;
    font-size: 14px;
  }
  .btn {
    cursor: pointer;
    width: 24px;
    height: 24px;
    line-height: 22px;
    border-radius: 4px;
    background-color: #00afff;
    border: 1px solid rgba(24, 144, 255, 1);
    text-align: center;
    color: #ffffff;
  }
  .btn2 {
    cursor: pointer;
    border-radius: 4px;
    width: 24px;
    height: 24px;
    line-height: 22px;
    border-radius: 4px;
    border: 1px solid rgba(0, 0, 0, 0.15);
    text-align: center;
    color: #000000;
    margin-top: 10px;
  }
}
</style>
